import { HubletPageStyles } from "../../components/Dashboard/HubletView/HubletViewStyles/HubletPageStyles";
import { TrendChartBinSizesEnum } from "../../types/enums";
import { useResetTrendChartBinSize } from "../DashboardPages/dashboardPagesUtils";

import { useIsRetrotagPopperOpen } from "utils/customHooks/retrotagSliceSelectors";
import { useProcessIdOnSingleProcessPage } from "components/CustomGridItems/LotInfoBar/lotInfoUtils";
import ErrorBoundary from "components/SimpleComponents/Errors/ErrorBoundary";
import useWindowSize from "utils/customHooks/useWindowSize";
import {
  DatepickerAndChartsStyles,
  SingleTimelineCardHubletPage,
} from "pages/HubletPage/DatepickerAndCharts";
import { useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { RangeSelectorCard } from "pages/DashboardPages/DashboardPagesContent/DashboardPagesSections/RangeSelectorCard";

const TimelineOnlyPage = () => {
  const [showRangeSelector, setShowRangeSelector] = useState(
    window.location.search.includes("showRangeSelector=true")
  );
  return (
    <TimelineOnlyPageStylesAndEffectsProvider>
      <ErrorBoundary id="DatepickerAndCharts">
        <div
          className="toggle-range-selector"
          style={{
            position: "absolute",
            top: 50,
            right: 0,
            left: 0,
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            pointerEvents: "none",
          }}
        >
          <Tooltip title="Toggle range selector">
            <IconButton
              style={{
                pointerEvents: "auto",
              }}
              onClick={() => setShowRangeSelector(!showRangeSelector)}
            >
              {showRangeSelector ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Tooltip>
        </div>
        <DatepickerAndChartsStyles className="datepickerAndCharts">
          {showRangeSelector ? <RangeSelectorCard /> : null}
          <div
            className={`datepickerAndCharts-size-observer cardsWrapper newDatePicker`}
          >
            <SingleTimelineCardHubletPage />
          </div>
        </DatepickerAndChartsStyles>
      </ErrorBoundary>
    </TimelineOnlyPageStylesAndEffectsProvider>
  );
};

function TimelineOnlyPageStylesAndEffectsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  // set trend chart to hourly bin size (only one allowed on Dashboard Pages)
  useResetTrendChartBinSize({
    newTrendChartBinSize: TrendChartBinSizesEnum.hours,
  });

  const processId = useProcessIdOnSingleProcessPage();
  const isRetrotagPopperOpen = useIsRetrotagPopperOpen(processId);

  // allow user to resize the HubletView, and store size in localStorage
  const { innerWidth } = useWindowSize();

  return (
    <HubletPageStyles
      $scale={1}
      data-component-name={"Timeline Only Page"}
      $isPnlPopupOpen={false}
      $isRetrotagPopperOpen={isRetrotagPopperOpen}
      key={innerWidth}
    >
      {children}
    </HubletPageStyles>
  );
}

export default TimelineOnlyPage;
